<template>
  <el-dialog title="Produkte Einbuchen" :visible="show" @close="close" width="30%">
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th> <l-checkbox v-model="selectAll" ref="toggleAll" @click="toggleSelectAll"></l-checkbox></th>
                <th>Menge</th>
                <th>Produkt</th>
                <th>Preis</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(orderProduct, index) in products" :key="orderProduct.id"
                :class="orderProduct.show ? '' : 'dont-buch'">
                <td v-if="orderProduct.pivot.quantity !== orderProduct.pivot.completed_quantity">
                  <l-checkbox v-model="orderProduct.show"></l-checkbox>
                </td>
                <td v-if="orderProduct.pivot.quantity !== orderProduct.pivot.completed_quantity">
                  <input style="min-width: 60px;" type="number" min="0"
                    :max="orderProduct.pivot.quantity - orderProduct.pivot.completed_quantity" class="form-control valid"
                    v-model="updatedQuantity[index]">
                </td>
                <td v-if="orderProduct.pivot.quantity !== orderProduct.pivot.completed_quantity">{{ orderProduct.name }}
                </td>
                <td v-if="orderProduct.pivot.quantity !== orderProduct.pivot.completed_quantity">
                  <price-input :price="orderProduct.pivot.price" @input="orderProduct.pivot.price = $event" />
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary">
              Einbuchen
            </button>
            <button class="btn btn-fill btn-default" @click.prevent="close">
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import PriceInput from 'src/components/price-input'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: ['show', 'order'],
  components: { [Dialog.name]: Dialog, PriceInput },
  data() {
    return {
      products: cloneDeep(this.order.products).map(product => { product.show = true; return product }),
      selectAll: true
    }
  },
  methods: {
    calculateQuantity(orderProduct) {
      return orderProduct.pivot.quantity - orderProduct.pivot.completed_quantity;
    },
    toggleSelectAll() {
      this.products.map(product => {
        product.show = !product.show
      })
    },
    submit() {
      const products = this.products.reduce((products, product, index) => {
        if (product.show) {
          products.push({
            product_id: product.id,
            quantity: product.pivot.completed_quantity !== null ? parseInt(this.updatedQuantity[index]) : parseInt(this.updatedQuantity[index]),
            totalCompletedQuantity: product.pivot.completed_quantity + parseInt(this.updatedQuantity[index]),
            price: product.pivot.price
          })
        }
        return products
      }, [])
      this.$http.put(`/orders/products/${this.order.id}`, { products }).then(({ data }) => {
        this.$emit('updateData')
      })
      this.$http.post(`/orders/${this.order.id}/products/stock_rotations`, { products }).then(({ data }) => {
        this.$notify({
          message: `Produkte der Bestellung erfolgreich eingebucht.`,
          type: 'success'
        })
        this.$emit('stockRotationsCreated', data)
      })
    },
    close() {
      this.$emit('close')
    }

  },
  computed: {
    updatedQuantity() {
      return this.products.map(orderProduct => {
        const quantity = orderProduct.pivot.quantity - orderProduct.pivot.completed_quantity;
        return parseInt(quantity, 10); // Convert the result to a number
      });
    }
  }

}
</script>

<style scoped>
.dont-buch {
  opacity: 0.5;
}
</style>
